import { v4 as uuid } from "uuid"

/**
 * Build a new `Outputs` Firestore doc for an activity. Mirrors the shape created
 * by the dedicated Outputs page (AddOutputs.jsx) so an output added inline in the
 * TOC navigator is identical to one added there. `client`, `timestamp` and the
 * colour are injected (the app's module-level singletons) so this stays pure.
 *
 * @param {object} args
 * @param {string} args.client - CompagnyID (tenant) of the caller.
 * @param {string} args.activityID - the parent activity's `ID` (not docid).
 * @param {string} args.color - a colour for the output (RandomColorGenerator).
 * @param {number} args.position - 1-based Position within the activity's outputs.
 * @param {*} args.timestamp - Firestore server/created timestamp.
 * @returns {object} the doc to write to the `Outputs` collection.
 */
const buildNewOutput = ({ client, activityID, color, position, timestamp }) => ({
    ID: uuid(),
    Compagny: client,
    CompagnyID: client,
    Timestamp: timestamp,
    Title: "",
    Description: "",
    Position: position,
    Color: color,
    ActivityID: activityID,
    LinkParticipantsToOutputs: "true",
})

export default buildNewOutput
